import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TrackeritemService } from '../../../services/trackeritem.service';

@Component({
    selector: 'ti-approval-panel',
    template: require('./ti-approval-panel.component.html')
})
export class TiApprovalPanelComponent implements OnInit {
    @Input() trackerItemId: number;
    @Input() transition: any;
    @Input() canApprove: boolean;
    @Input() saveError = false;
    @Output() approved = new EventEmitter<any>();

    note = '';
    isSubmitting = false;
    isApproved = false;
    error = '';

    constructor(private trackeritemService: TrackeritemService) {}

    get roleNames(): string {
        const roles: any[] = (this.transition && this.transition.toEl && this.transition.toEl.allowedRoles) || [];
        if (!roles.length) return 'an Approver';
        return roles.map((r: any) => r.roleName).join(', ');
    }

    ngOnInit(): void {
        console.log('[ti-approval-panel] canApprove:', this.canApprove);
        console.log('[ti-approval-panel] transition:', this.transition);
        console.log('[ti-approval-panel] trackerItemId:', this.trackerItemId);
        console.log('[ti-approval-panel] allowedRoles:', this.transition && this.transition.toEl && this.transition.toEl.allowedRoles);
    }

    recordApproval(): void {
        this.isSubmitting = true;
        this.error = null;
        const payload = {
            eventType: 'approval',
            fromElementId: this.transition.fromEl.id,
            toElementId: this.transition.toEl.id,
            note: this.note
        };
        this.trackeritemService.postEvent(this.trackerItemId, payload)
            .then((result: any) => {
                this.isApproved = true;
                this.isSubmitting = false;
                this.approved.emit(result);
            })
            .catch((err: any) => {
                this.isSubmitting = false;
                this.error = (err && err.error && err.error.message)
                    ? err.error.message
                    : 'Could not record approval. Please try again.';
                return err;
            });
    }
}
